import { createAction } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentEnterpriseUserPreferredServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { SELECT_SERVICE } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';

export const preselectDefaultServiceId = (): CommanderThunkAction => (dispatch, getState) => {
    const serviceId = getCurrentEnterpriseUserPreferredServiceId(getState());
    return dispatch(createAction(SELECT_SERVICE, { serviceId }));
};
